var map = {
	"./bitharvest/PrivacyPolicy.vue": [
		"d8b5",
		"chunk-dba725f2",
		"chunk-b511f4c2"
	],
	"./default/PrivacyPolicy.vue": [
		"718a",
		"chunk-dba725f2",
		"chunk-1c800064"
	],
	"./oripay/PrivacyPolicy.vue": [
		"a471",
		"chunk-dba725f2",
		"chunk-7b61a8d5"
	],
	"./touareg/PrivacyPolicy.vue": [
		"4d78",
		"chunk-9dd6a472"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a063";
module.exports = webpackAsyncContext;